export default   [
        {
            path: '/demo',
            // which is lazy-loaded when the route is visited.
            component: () => import( '@/views/demo/demos.vue'),
            meta: {
                title: '例子',
                requireAuth: true
            },
        },
    {
        path: '/demo/shuxuejisuan',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/demo/shuxuejisuan.vue'),
        meta: {
            title: '数学计算',
            requireAuth: true
        },
    },
        {
            path: '/demo/tables',
            // which is lazy-loaded when the route is visited.
            component: () => import( '@/views/demo/tables.vue'),
            meta: {
                title: '表格',
                requireAuth: true
            }
        },
        {
            path: '/demo/forms',
            // which is lazy-loaded when the route is visited.
            component: () => import( '@/views/demo/forms.vue'),
            meta: {
                title: '表单',
                requireAuth: true
            }
        },
    {
        path: '/demo/lyytest',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/demo/lyytest.vue'),
        meta: {
            title: 'lyy测试专用',
            isTabsPage: true,
            keepAlive:true
        }
    },
    // {
    //     path: '/invoice/invoiceList',
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import( '@/views/invoice/invoiceList.vue'),
    //     meta: {
    //         title: '发票列表',
    //         isTabsPage: true,
    //         keepAlive:true
    //     }
    // },
    {
        path: '/invoice/invoiceNew',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/invoice/invoiceNew.vue'),
        meta: {
            title: '发票列表',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/invoice/invoiceTheEnd',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/invoice/viewinvoicetheend.vue'),
        meta: {
            title: '一票到底',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/invoice/applyList',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/invoice/apply/applyList.vue'),
        meta: {
            title: '可开票确认',
            isTabsPage: true,
            keepAlive:false
        }
    },
    {
        path: '/invoice/searchApplyNew',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/invoice/apply/searchApplyNew.vue'),
        meta: {
            title: '可开票确认',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/invoice/searchApplySupplier',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/invoice/apply/searchApplySupplier.vue'),
        meta: {
            title: '供应商退税开票',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/invoice/applyCheck',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/invoice/applyCheck.vue')
    },
    {
        path: '/invoice/materialReduceCost',
        component:()=>import('@/views/invoice/materialReduceCost.vue'),
        meta: {
            title: '物料号采购降成本',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/invoice/supplierReduceCost',
        component:()=>import('@/views/invoice/supplierReduceCost.vue'),
        meta: {
            title: '供应商采购降成本',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/invoice/reduceCostHistory',
        component:()=>import('@/views/invoice/reduceCostHistory.vue'),
        meta: {
            title: '采购调价记录',
            isTabsPage: true,
            keepAlive: true
        }
    },
    {
        path: '/invoice/reduceCostHistoryShenpi',
        component:()=>import('@/views/invoice/reduceCostHistoryShenpi.vue'),
        meta: {
            title: '采购调价记录审批',
            isTabsPage: false,
            keepAlive: false
        }
    },
    {
        path: '/invoice/reformCatalogList',
        component:()=>import('@/views/invoice/reformCatalog/reformCatalogList.vue'),
        meta: {
            title: '改制目录',
            isTabsPage: true,
            keepAlive: true
        }
    },
    // 改制目录新增
    {
        path: '/invoice/createReformCatalog',
        component:()=>import('@/views/invoice/reformCatalog/createReformCatalog.vue'),
        meta: {
            title: '新增改制目录',
            isTabsPage: true,
            keepAlive: true
        }
    },
    // 改制目录详情
    {
        path: '/invoice/reformCatalogDetailPage',
        component:()=>import('@/views/invoice/reformCatalog/reformCatalogDetailPage.vue'),
        meta: {
            title: '改制目录详情',
            isTabsPage: true,
            keepAlive: true
        }
    },
    // 编辑改制目录
    {
        path: '/invoice/updateReformCatalog',
        component:()=>import('@/views/invoice/reformCatalog/updateReformCatalog.vue'),
        meta: {
            title: '编辑改制目录',
            isTabsPage: true,
            keepAlive: true
        }
    },
    // 改制目录审批
    {
        path: '/invoice/shenPiReformCatalog',
        component:()=>import('@/views/invoice/reformCatalog/shenPiReformCatalog.vue'),
        meta: {
            title: '改制目录审批',
            isTabsPage: true,
            keepAlive: true
        }
    }
]
